import request from "@/utils/request";
//分页查询所有的行业资讯
export function getIndustryinfoList(data) {
  return request({
    url: '/zwb/app/industryinfo/list',
    method: 'post',
    data
  })
}

//根据id查询资讯详情
export function getIndustryinfoById(data) {
  return request({
    url: `/zwb/app/industryinfo/${data}`,
    method: 'post',
  })
}


//分页查询评价列表
export function getCommonList(data) {
  return request({
    url: "/zwb/app/comment/list",
    method: "post",
    data
  })
}

//发表评价
export function addCommon(data) {
  return request({
    url: "/zwb/app/comment/publish",
    method: "post",
    data
  })
}

//分页查询专家库列表
export function getExpertList(data) {
  return request({
    url: "/zwb/app/page/expert",
    method: "post",
    data
  })
}

//分页查询技术内容
export function getTechnologyList(data) {
  return request({
    url: "/zwb/app/technology/list",
    method: "post",
    data
  })
}

//根据id查询技术内容详情
export function getTechnologyListById(params) {
  return request({
    url: "/zwb/app/technology/info",
    method: "get",
    params
  })
}

//获取分类别
export function getDictList(params) {
  return request({
    url: "/zwb/app/get/dict/front",
    method: "get",
    params
  })
}

// 分页查询资料中心列表
export function getDataList(data) {
  return request({
    url: "/zwb/app/datacenter/listall",
    method: "post",
    data
  })
}

// 根据id查询资料详情
export function getDataDetailById(params) {
  return request({
    url: "/zwb/app/datacenter/info",
    method: "get",
    params
  })
}

//分页查询活动列表
export function getActivityList(data) {
  return request({
    url: "/zwb/app/activity/list",
    method: "post",
    data
  })
}
//分页查询活动列表
export function getActivityJiCaiList(data) {
  return request({
    url: "/zwb/app/activityJiCai/list",
    method: "post",
    data
  })
}

//分页查询所有课程
export function getLessonList(data) {
  return request({
    url: "/zwb/app/college/list",
    method: "post",
    data
  })
}

// 分页查询专访视频
export function getInterviewList(data) {
  return request({
    url: "/zwb/app/enterpriseInterview/list",
    method: "post",
    data
  })
}

//获取类型课件
export function getRandomLessonList(params) {
  return request({
    url: "/zwb/app/college/public/rondomdata",
    method: "get",
    params
  })
}

//根据id查询课程详情
export function getLessonDetailById(params) {
  return request({
    url: "/zwb/app/college/info",
    method: "get",
    params
  })
}

//根据id查询企业专访详情
export function getInterviewDetailById(params) {
  return request({
    url: "/zwb/app/enterpriseInterview/info",
    method: "get",
    params
  })
}

//关于我们
export function aboutus(params) {
  return request({
    url: "/zwb/app/aboutus/list",
    method: "get",
    params
  })
}

//查询企业
export function getCompanyList(data) {
  return request({
    url: "/zwb/app/page/enterprise",
    method: "post",
    data
  })
}

//查询用户信息
export function getUserInfo(params) {
  return request({
    url: "/zwb/app/public/userinfo",
    method: "get",
    params
  })
}

//查询供应产品
export function getProduct(data) {
  return request({
    url: "/zwb/app/supply/public/list",
    method: "post",
    data
  })
}

//查询供应产品详情
export function getProductDetail(params) {
  return request({
    url: "/zwb/app/supply/public/info",
    method: "get",
    params
  })
}

//查询需求列表
export function getDemandList(data) {
  return request({
    url: "/zwb/app/demand/public/list",
    method: "post",
    data
  })
}

// 查询人力资源列表
export function getDemandRecruitList(data) {
  return request({
    url: "/zwb/app/demandRecruit/public/list",
    method: "post",
    data
  })
}

//查询需求详情

export function getDemandDetail(params) {
  return request({
    url: "/zwb/app/demand/public/info",
    method: "get",
    params
  })
}

// 查询人力资源详情
export function getDemandRecruitDetail(params) {
  return request({
    url: "/zwb/app/demandRecruit/public/"+params,
    method: "get",
    // params
  })
}

//活动报名
export function activityReg(data) {
  return request({
    url: "/zwb/app/activity/reg",
    method: "post",
    data
  })
}
//活动报名
export function activityJiCaiReg(data) {
  return request({
    url: "/zwb/app/activityJiCai/reg",
    method: "post",
    data
  })
}

//获取banner
export function getBanner(params) {
  return request({
    url: "/zwb/app/banner/list",
    method: "get",
    params
  })
}

//查询广告
export function getAdv(data) {
  return request({
    url: "/zwb/app/advertising/list",
    method: "post",
    data
  })
}

//企业分类筛选
export function getCompanyByCate(data) {
  return request({
    url: "/zwb/app/public/queryTypeByCompanyList",
    method: "post",
    data
  })
}

//获取资料中心试读文件
export function getDataCenterFile(params) {
  return request({
    url: "/zwb/app/datacenter/trialreading",
    method: "get",
    params
  })
}

//获取环学院试读文件
export function getCollegeFile(params) {
  return request({
    url: "/zwb/app/college/trialreading",
    method: "get",
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/information.js